export default __webpack_public_path__ + "static/media/pexels-george-morina-5687581.38a41b0d.mp4";